export { Severity } from './severity';
export { SeverityLevels } from './severity';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/types/esm/index.js
// module id = 33
// module chunks = 0